const SEARCH_SCREEN_TYPES = {
   dashboardBusinessSearch: "DASHBOARD",
   categoryBusinessSearch: "CATEGORY",
   frequentlyOrderedBusinessSearch: "FREQUENTLY_ORDERED",
   topRatedBusinessSearch: "TOP_RATED",
   PopularBusinessSearch: "POPULAR",
   assuredBusinessSearch: "ASSURED",
   newStoresBusinessSearch: "NEW_STORES",
   BRBBusinessSearch: "BRB",
   preOrderBusinessSearch: "PRE_ORDER",
   catalogScreen: "CATALOG"
  };

const ENVIRONMENTS = [
  {
    key: "localhost",
    match: "http://localhost:8000",
    env: "local",
    domain: "http://localhost:8000",
  },
  {
    key: "swifts",
    match: "swifts",
    env: "dev",
    domain: "https://swifts.xirify.com",
  },
  {
    key: "vulture",
    match: "vulture",
    env: "qa",
    domain: "https://vulture.xirify.com",
  },
  {
    key: "uat",
    match: "uat",
    env: "uat",
    domain: "https://uat.xirify.com",
  },
  {
    key: "platform",
    match: "platform",
    env: "platform",
    domain: "https://platform.xirify.com",
  },
  {
    key: "demo",
    match: "demo",
    env: "ecommnxt",
    domain: "https://demo.ecommnxt.com",
  },
  {
    key: "trial",
    match: "trial",
    env: "ecommnxt-trial",
    domain: "https://trial.ecommnxt.com",
  },
  {
    key: "uatadigreen",
    match: "uatadigreen",
    env: "adigreen-uat",
    domain: "https://uatadigreen.ecommnxt.com",
  },
  {
    key: "adigreen",
    match: "adigreen",
    env: "adigreen",
    domain: "https://adigreen-ecommnxt.com",
  },
];

// Special environment keys that use ecommnxt domain structure
const SPECIAL_ENV_KEYS = ["demo", "trial", "adigreen"];

// Extracts environment from a URL/host using ENVIRONMENTS list.
// - First tries exact match on subdomain (e.g. "platform" from https://platform.xirify.com/...)
// - Then falls back to longest "includes" match (handles localhost full match, etc.)
const getMatchedEnvironment = (inputUrl = "") => {
  const value = (inputUrl || "").toString();

  // Extract first label of hostname: https://platform.xirify.com -> "platform"
  let extractedDomain = "";
  const urlMatch = value.match(/\/\/([^\/\.]+)/);
  if (urlMatch && urlMatch[1]) extractedDomain = urlMatch[1];

  let matchedEnv = null;
  if (extractedDomain) {
    matchedEnv = ENVIRONMENTS.find((env) => extractedDomain === env.match);
  }

  if (!matchedEnv) {
    matchedEnv = [...ENVIRONMENTS]
      .sort((a, b) => (b.match || "").length - (a.match || "").length)
      .find((env) => value.includes(env.match));
  }

  return matchedEnv || { key: "", env: "", domain: "" };
};

const buildBusinessUrl = ({ callbackUrl = "", businessName = "", businessId = "" }) => {
  const matchedEnv = getMatchedEnvironment(callbackUrl);
  const envVariable = matchedEnv.env || "";
  const safeBusinessName = (businessName || "").replace(/\s+/g, "_");
  const safeBusinessId = businessId || "";

  if (!envVariable || !safeBusinessName) return "";

  return SPECIAL_ENV_KEYS.includes(matchedEnv.key)
    ? `https://${envVariable}-ecommnxt.web.app/${safeBusinessName}?businessId=${safeBusinessId}`
    : `https://xirify-${envVariable}.web.app/${safeBusinessName}?businessId=${safeBusinessId}`;
};

 module.exports = {
   SEARCH_SCREEN_TYPES,
   ENVIRONMENTS,
   SPECIAL_ENV_KEYS,
   getMatchedEnvironment,
   buildBusinessUrl,
 }